<template>
    <div class="mb-4">
        <template v-for="(item, idx) of items" :key="idx">
            <CardPrivilegesCategoryItem :item="item"></CardPrivilegesCategoryItem>
        </template>
        <!-- <CardPrivilegesCategoryItem></CardPrivilegesCategoryItem> -->
    </div>
</template>
<script>
import CardPrivilegesCategoryItem from "./CardPrivilegesCategoryItem.vue";
//helper
import Locale from "@/helper/locale/Locale.js";
import Util from "@/helper/Utility.js";

//service
import { SubDashboardConfigBuilder } from "@/core/Campaign/config/DashboardConfigModel.js";
import BzbsDashboard from "@/core/Campaign/service/BzbsDashboard.js";

// mixins
import LocaleMixin from "@/mixin/LocaleMixin"
import ErrorApiMixin from "@/mixin/ErrorApiMixin"

// config
import ConfigManager from "@/config/ConfigManager";

export default {
    name: 'CardPrivilegesList',
    props: {
        modalController: { type: Object }
    },
    components: {
        CardPrivilegesCategoryItem
    },
    mixins: [LocaleMixin, ErrorApiMixin],
    emits: ["onLoaded", "onError"],
    data: function () {
        return {
            dashboardConfig: ConfigManager.getDashboardConfig(),
            items: []
        }
    },
    computed: {},
    mounted: function () {
        this.getCardPrivilege()
    },
    methods: {
        getCategory: function () {
            var dashboardConfig = ConfigManager.getDashboardSearchPromotionConfig();
            var configBuilder = new SubDashboardConfigBuilder();
            configBuilder.setLocale(Locale.getLocaleCode());

            var params = configBuilder.create().getParams();
            BzbsDashboard.apiGetSubDashboard(params, dashboardConfig).subscribe({
                next: (categories) => {
                    this.items = categories
                    Util.log(this.items)
                },
                error: (err) => {
                    this.errorApi(err);
                },
            })
        },
        getCardPrivilege: function(){
            var dashboardConfig = ConfigManager.getDashboardCardPrivilege();
            var configBuilder = new SubDashboardConfigBuilder();
            configBuilder.setLocale(Locale.getLocaleCode());

            var params = configBuilder.create().getParams();
            BzbsDashboard.apiGetSubDashboard(params, dashboardConfig).subscribe({
                next: (privilage) => {
                    this.items = privilage
                    // Util.log(this.items)
                },
                error: (err) => {
                    this.errorApi(err);
                },
            })
        }
    }
}
</script>
